$mol_button_share $mol_button_minor
	uri \
	capture null
	hint @ \Share
	sub /
		<= Icon $mol_icon_share_variant
		<= title \
